import { render, staticRenderFns } from "./CollectionCreatorShowExtensions.vue?vue&type=template&id=98f1127a"
import script from "./CollectionCreatorShowExtensions.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCreatorShowExtensions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports